import React, { useMemo } from "react";
import { useToogle } from "../../hooks";
import {
  AnnuaireEmail,
  AnnuaireName,
  AnnuaireProfile,
  AnnuaireSearchGate,
  AnnuaireSpeciality,
  ArrowSee,
  BoxSee,
  EmailLink,
  LabelP,
  TextDiv,
} from "../../pages/homepage/contact/Sannuaire";
import { ShowMore } from "./ShowMore";

export const BoxAnnuaire = ({ data }) => {
  const [show, toogleShow] = useToogle(false);
  const emails = useMemo(
    () =>
      data?.email
        ? Array.isArray(data.email)
          ? data.email
          : [data.email]
        : [],
    [data.email]
  );
  return (
    <>
      <BoxSee onClick={toogleShow}>
        <AnnuaireProfile>
          <img src={data.img} alt="profile" />
        </AnnuaireProfile>
        <TextDiv>
          <AnnuaireName style={{color:"#00a74b"}}>{data.name}</AnnuaireName>
          <p>{data.status}</p>
          <AnnuaireSpeciality>
            <LabelP>Spécialité: </LabelP>
            {data.speciality}
          </AnnuaireSpeciality>
          <AnnuaireEmail>
            <LabelP>E-mail: </LabelP>
            {emails.map((mail, index) => (
              <>
                <EmailLink key={index} href={`mailto:${mail}`}>
                  {mail}
                </EmailLink>
                {emails.length - 1 !== index ? ", " : ""}
              </>
            ))}
          </AnnuaireEmail>
          {data.researchGate && (
            <AnnuaireSearchGate href={data.researchGate} target="_blenk">
              ResearchGate
            </AnnuaireSearchGate>
          )}
          {data.orcid && (
            <AnnuaireSearchGate href={data.orcid} target="_blenk">
              ORCID
            </AnnuaireSearchGate>
          )}
        </TextDiv>
        <ArrowSee />
      </BoxSee>
      {show && <ShowMore data={data} toogle={toogleShow} />}
    </>
  );
};

export default BoxAnnuaire;
